import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Actions from 'actions/Actions';
import MfaActions from 'actions/mfaActions';
import UserActions from 'actions/UserActions';

import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';

import PhoneVerificationModalEN from 'components/GlobalModals/PhoneVerificationModal/locales/PhoneVerificationModal_en_US';
import PhoneVerificationModalFR from 'components/GlobalModals/PhoneVerificationModal/locales/PhoneVerificationModal_fr_CA';

import { MFA_MODE } from 'constants/phoneVerification';
import anaConsts from 'analytics/constants';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(PhoneVerificationModalEN, PhoneVerificationModalFR);

const localization = createStructuredSelector({
    modalTitle: getTextFromResource(getText, 'modalTitle'),
    heading: getTextFromResource(getText, 'heading'),
    otpHeading: getTextFromResource(getText, 'otpHeading'),
    otpSubheading: getTextFromResource(getText, 'otpSubheading'),
    otpSubheadingCont: getTextFromResource(getText, 'otpSubheadingCont'),
    subheading: getTextFromResource(getText, 'subheading'),
    phoneOnFilePrefix: getTextFromResource(getText, 'phoneOnFilePrefix'),
    phoneOnFileSuffix: getTextFromResource(getText, 'phoneOnFileSuffix'),
    enterPhoneNumber: getTextFromResource(getText, 'enterPhoneNumber'),
    sendButton: getTextFromResource(getText, 'sendButton'),
    cancelButton: getTextFromResource(getText, 'cancelButton'),
    resendButton: getTextFromResource(getText, 'resendButton'),
    noAccessTextPrefix: getTextFromResource(getText, 'noAccessTextPrefix'),
    sendToEmailButton: getTextFromResource(getText, 'sendToEmailButton'),
    privacyNote: getTextFromResource(getText, 'privacyNote'),
    termsOfUse: getTextFromResource(getText, 'termsOfUse'),
    privacyNoteEnd: getTextFromResource(getText, 'privacyNoteEnd'),
    privacyPolicy: getTextFromResource(getText, 'privacyPolicy'),
    errorInvalidPhone: getTextFromResource(getText, 'errorInvalidPhone'),
    errorPhoneMismatch: getTextFromResource(getText, 'errorPhoneMismatch'),
    errorMaxAttempts: getTextFromResource(getText, 'errorMaxAttempts'),
    errorProfileNotFound: getTextFromResource(getText, 'errorProfileNotFound'),
    errorTokenExpired: getTextFromResource(getText, 'errorTokenExpired'),
    errorInvalidEmail: getTextFromResource(getText, 'errorInvalidEmail'),
    errorMissingParameters: getTextFromResource(getText, 'errorMissingParameters'),
    errorInternalServer: getTextFromResource(getText, 'errorInternalServer'),
    errorNetwork: getTextFromResource(getText, 'errorNetwork'),
    remainingAttempts: (state, ownProps) => getTextFromResource(getText, 'remainingAttempts', [ownProps.remainingAttempts])(state),
    sending: getTextFromResource(getText, 'sending'),
    accessibilityPhoneInput: getTextFromResource(getText, 'accessibilityPhoneInput'),
    accessibilityError: getTextFromResource(getText, 'accessibilityError'),
    tooManyAttempts: getTextFromResource(getText, 'tooManyAttempts'),
    emailVerification: getTextFromResource(getText, 'emailVerification'),
    didntGetSms: getTextFromResource(getText, 'didntGetSms'),
    needAnotherSms: getTextFromResource(getText, 'needAnotherSms'),
    seconds: getTextFromResource(getText, 'seconds'),
    errorInvalidOtp: getTextFromResource(getText, 'errorInvalidOtp'),
    errorInternalServerOTP: getTextFromResource(getText, 'errorInternalServerOTP'),
    errorMaxAttemptOtp: getTextFromResource(getText, 'errorMaxAttemptOtp'),
    gotIt: getTextFromResource(getText, 'gotIt'),
    expiredOTPTitle: getTextFromResource(getText, 'expiredOTPTitle'),
    expiredOTP: getTextFromResource(getText, 'expiredOTP'),
    sendNewCode: getTextFromResource(getText, 'sendNewCode'),
    infoTitle: getTextFromResource(getText, 'infoTitle'),
    infoMessage: getTextFromResource(getText, 'infoMessage')
});

const fields = createStructuredSelector({ localization });

const functions = (dispatch, ownProps) => ({
    dispatch,
    onDismiss: () => {
        dispatch(Actions.showPhoneVerificationModal({ isOpen: false }));
        dispatch(Actions.showSignInModal({ isOpen: true }));
    },
    onSwitchToEmail: ({ previousPageName }) => {
        // Send anlytics data for ACS-2685 AC4 after user clicks "Send to Email" button
        const analyticsData = {
            linkData: anaConsts.LinkData.PHONE_VERIFICATION_SEND_TO_EMAIL, // prop55
            previousPageName // prop6
        };

        dispatch(Actions.showPhoneVerificationModal({ isOpen: false }));
        dispatch(Actions.showEmailVerificationModal({ isOpen: true, email: ownProps.email, analyticsData }));
    },
    displayInfoModal: (infoModalOptions = {}) => {
        dispatch(
            Actions.showInfoModal({
                ...infoModalOptions,
                isOpen: true
            })
        );
    },
    sendPhoneOTP: phone => dispatch(MfaActions.validateMFAEmailPhone(phone, ownProps.email, MFA_MODE.PHONE)),
    checkOTP: otpCode => dispatch(MfaActions.validateOTP(ownProps.email, otpCode, MFA_MODE.PHONE, ownProps.keepSignedIn)),
    onMFASuccess: response => {
        // Close the phone verification modal
        dispatch(Actions.showPhoneVerificationModal({ isOpen: false }));
        // Dispatch the signInSuccessAfterMFA action to complete the login flow
        dispatch(
            UserActions.signInSuccessAfterMFA(
                response,
                ownProps.email,
                ownProps.keepSignedIn,
                ownProps.successCallback,
                ownProps.biAccountInfo,
                ownProps.analyticsData,
                ownProps.anonymousToken
            )
        );
    }
});

const withPhoneVerificationModalProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withPhoneVerificationModalProps
};
